(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ctr-gift-product-widget"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('ctrGiftProductWidget', (opts = {}) => ({
      giftProduct: null,
      title: opts.title ?? '',
      currentVariant: null,
      currentVariantId: opts.currentVariantId ?? null,
      variants: [],
      currencyDivider: opts.currencyDivider ?? 100,
      isGiftProductAvailable: false,
      isGiftProductInCart: false,
      pricePattern: opts.pricePattern ?? '[amount]',

      getData(data) {
        this.giftProduct = data.giftProduct;
        this.title = data.title;
        this.isGiftProductAvailable = data.isGiftProductAvailable;
        this.isGiftProductInCart = data.isGiftProductInCart;
        this.variants = data.giftProduct.variants.filter((variant) => variant.available);
        this.currentVariantId = this.variants[0]?.id ?? null;
        this.currentVariant = this.variants[0] ?? null;
      },

      formatPrice(price) {
        if (!price) return this.pricePattern.replace('[amount]', '0.00');

        return this.pricePattern.replace('[amount]', (Number(price) / this.currencyDivider).toFixed(2));
      },

      updateCurrentVariant(variantId) {
        this.currentVariantId = variantId;
        this.currentVariant = this.variants.find((variant) => variant.id === this.currentVariantId) ?? null;
      },

      init() {
        this.$watch(
          () => this.currentVariantId,
          (variantId) => {
            this.updateCurrentVariant(Number(variantId));
          }
        );
      },

      addGiftProduct(giftProductId) {},
    }));
  });
  } catch(e) { console.error(e); }
})();

})();
